/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import {
  AppBar,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
} from "@mui/material";
import axios from "axios";
import TimelineItem from "components/Icon/TimelineItem";
import MDBox from "components/MDBox";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog/DeleteConfirmationDialog";
import Height from "components/height/height";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import DataTable from "examples/Tables/DataTable";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { appConstants } from "utils/appConstants";

let LOGIN_DETAILS;
let searchParameter = "";
let checkListStatus = "";

function Checklist() {
  const [selectedId, setSelectedId] = useState("");
  const [selectedId1, setSelectedId1] = useState("");
  const [screenName, setScreenName] = useState(" Driver Checklist");
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);
  const [ShowBusinessUserChecklist, setShowBusinessUserChecklist] =
    useState(false);
  const [ShowAllChecklist, setShowAllChecklist] = useState(false);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [table, setTable] = useState("AllChecklist");
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [searchText, setSearchText] = useState("");

  const [values, setValues] = React.useState({
    checkListName: "",
    checkListSequence: "",
    checkListType: "",
    businessUserID: "",
    checkListStatus: "",
    _id: "",
  });

  useEffect(() => {
    if (sessionStorage.getItem("PARA_TABLE") === "BusinessUserChecklist") {
      setTable("BusinessUserChecklist");
    }
    if (table === "AllChecklist") {
      setShowAllChecklist(true);
      setShowBusinessUserChecklist(false);
      setTabValue(0);
    } else if (table === "BusinessUserChecklist") {
      setShowAllChecklist(false);
      setShowBusinessUserChecklist(true);
      setTabValue(1);
    }
    sessionStorage.removeItem("PARA_TABLE");
  }, [table]);

  const handleDeleteDialogeClick = async (_id) => {
    setSelectedId(_id);
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  const handleDelete = async (id) => {
    deleteChecklist();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleDeleteDialogeClick1 = async (_id) => {
    setSelectedId1(_id);
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleDelete1 = async (id) => {
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  LOGIN_DETAILS = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"));
  values.businessUserID = LOGIN_DETAILS.businessUserID;

  const deleteChecklist = async () => {
    try {
      values._id = selectedId;
      setLoading(false);
      await axios
        .post(appConstants.baseURL + "checklist/deleteChecklist", values)
        .then((res) => {
          setLoading(false);
          let response = res.data;
          if (response.Result_Status) {
            swal({
              title: "Deleted successfully!",
              text: " ",
              icon: "success",
              color: "green",
              button: false,
              timer: 1500,
            });
            setTimeout(() => {
              window.location.href = "/NewChecklist";
            }, 1000);
          } else {
            swal({
              title: response.Result_Message,
              text: " ",
              icon: "error",
              color: "red",
              button: false,
              timer: 2000,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in deleteStandardPlanFeature API=", error);
        });
    } catch (error) {
      console.log("Catch in deleteStandardPlanFeature API=", error);
    }
  };

  useEffect(() => {
    fetchChecklist();
  }, []);
  const fetchChecklist = async () => {
    values.searchParameter = searchParameter;
    values.checkListStatus = checkListStatus;
    setLoading(true);
    await axios
      .post(appConstants.baseURL + "checklist/fetchChecklist", values)
      .then((res) => {
        setLoading(false);
        setRows(res.data.Result_Output);
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error in fetchChecklist=" + JSON.stringify(error));
      });
  };
  // const fetchBusinessUserChecklist = async () => {

  //   setLoading(true)
  //   await axios.post(appConstants.baseURL + '/', values)
  //       .then(
  //           (res) => {
  //               setLoading(false);
  //              setRowsPick(res.data.Result_Output)
  //           }
  //       )
  //       .catch(

  //           (error) => { setLoading(false); console.log("Error in fetchBusinessUserChecklist=" + JSON.stringify(error)) }
  //       );

  // }

  const searchFilter = (rows, searchText) => {
    return rows.filter((row) =>
      Object.values(row).some(
        (value) =>
          typeof value === "string" &&
          value.toLowerCase().includes(searchText.toLowerCase())
      )
    );
  };

  const optionFilter = (rows, selectedStatus) => {
    return rows.filter(
      (row) =>
        row.checkListStatus.toLowerCase() === selectedStatus.toLowerCase()
    );
  };

  const filteredData = selectedStatus
    ? optionFilter(searchFilter(rows, searchText), selectedStatus)
    : searchFilter(rows, searchText);

  const selectedValue = (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label"> Checklist Status </InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        style={{ minHeight: "3.1em" }}
        label="Driver Checklist Status"
        value={selectedStatus}
        onChange={(e) => setSelectedStatus(e.target.value)}
      >
        <MenuItem value="Active">Active</MenuItem>
        <MenuItem value="Inactive">Inactive</MenuItem>
      </Select>
    </FormControl>
  );

  const NewChecklistTab = (
    <>
      {ShowAllChecklist && (
        <MDBox mb={3}>
          <DataTable
            style={{ marginTop: "0px" }}
            loading={loading}
            addNew={true}
            link="/addNewChecklist"
            canSearch={true}
            selectedValue={selectedValue}
            table={{
              rows: filteredData,

              columns: [
                {
                  Header: "Checklist Name",
                  accessor: "checkListName",
                  align: "left",
                },
                {
                  Header: "Checklist Sequence",
                  accessor: "checkListSequence",
                  align: "center",
                },
                {
                  Header: "Checklist Type ",
                  accessor: "checkListType",
                  align: "center",
                },
                {
                  Header: "Checklist Status ",
                  accessor: "checkListStatus",
                  align: "center",
                },
                {
                  Header: "actions",
                  align: "center",
                  accessor: "_id",
                  Cell: ({ value }) => (
                    <>
                      <Grid container spacing={5} mt={-6.2}>
                        <Grid item style={{ marginLeft: "-20px" }}>
                          <Link to={`/editChecklist/edit/${value}`}>
                            <TimelineItem
                              color="success"
                              icon="edit"
                              title="Edit"
                            />
                          </Link>
                        </Grid>
                        <Grid item>
                          <TimelineItem
                            color="error"
                            icon="delete"
                            onClick={() => handleDeleteDialogeClick(value)}
                            title="Delete"
                          />
                        </Grid>
                      </Grid>
                    </>
                  ),
                },
              ],
            }}
            isSorted={true}
            entriesPerPage={true}
            showTotalEntries={true}
            pagination={{ variant: "gradient" }}
            noEndBorder
          />{" "}
        </MDBox>
      )}
    </>
  );
  const BusinessUserChecklistTab = (
    <>
      {ShowBusinessUserChecklist && (
        <MDBox mb={3}>
          <DataTable
            style={{ marginTop: "0px" }}
            loading={loading}
            // onReload={() => reloadData()}
            addNew={true}
            link="/addBusinessUserChecklist"
            table={{
              rows,

              columns: [
                {
                  Header: "Business User Name ",
                  accessor: "businessUsername",
                  align: "left",
                },
                {
                  Header: "Number Of Checklist ",
                  accessor: "numberofChecklist",
                  align: "center",
                },
                {
                  Header: "actions",
                  align: "center",
                  accessor: "_id",
                  Cell: ({ value }) => (
                    <>
                      <Grid container spacing={5} mt={-6.2}>
                        <Grid item style={{ marginLeft: "-20px" }}>
                          <Link to={`/editBusinessUserChecklist/edit/${value}`}>
                            <TimelineItem
                              color="success"
                              icon="edit"
                              title="Edit"
                            />
                          </Link>
                        </Grid>
                        <Grid item>
                          <TimelineItem
                            color="error"
                            icon="delete"
                            onClick={() => handleDeleteDialogeClick1(value)}
                            title="Delete"
                          />
                        </Grid>
                      </Grid>
                    </>
                  ),
                },
              ],
            }}
            isSorted={true}
            entriesPerPage={true}
            showTotalEntries={true}
            pagination={{ variant: "gradient" }}
            noEndBorder
          />{" "}
        </MDBox>
      )}
    </>
  );
  const renderTable = () => {
    return (
      <>
        {NewChecklistTab}
        {BusinessUserChecklistTab}
      </>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Height val={30} />
      <Card>
        <PageTitle screenName={screenName} />
        <Grid container>
          <Grid item xs={12} md={6} lg={6} px={2} mb={-3.5}>
            <AppBar position="inherit">
              <Tabs
                orientation={tabsOrientation}
                value={tabValue}
                onChange={handleSetTabValue}
                indicatorColor={"primary"}
                sx={{
                  "& .Mui-selected": { color: "#fff !important" },
                }}
              >
                <Tab
                  onClick={() => setTable("AllChecklist")}
                  label="All Checklist"
                />
                <Tab
                  onClick={() => setTable("BusinessUserChecklist")}
                  label="Business User Checklist"
                />
              </Tabs>
            </AppBar>
          </Grid>
        </Grid>

        {renderTable()}
      </Card>

      <DeleteConfirmationDialog
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />

      <DeleteConfirmationDialog
        open={deleteDialogeFlag}
        handleDelete={handleDelete1}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
    </DashboardLayout>
  );
}

export default Checklist;
